exports.Data = {
  "tables": {
    "Medication": [
      {
        "Impairment Category": "Lifestyle ",
        "Impairment": "N/A ",
        "Rx Name": "ALPRAZOLAM ",
        "Rx Type": "Benzodiazepines ",
        "Start Date": "05/19/2011 ",
        "End Date": "",
        "Rx Date": "06/01/2015 ",
        "Page": 33,
        "FIELD9": ""
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "N/A ",
        "Rx Name": "ASA ",
        "Rx Type": "NSAIDS ",
        "Start Date": "03/17/2010 ",
        "End Date": "",
        "Rx Date": "06/01/2015 ",
        "Page": 33,
        "FIELD9": ""
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "Hyperlipidemia ",
        "Rx Name": "ATORVASTATIN CALCIUM ",
        "Rx Type": "HMG CoA Reductase Inhibitors ",
        "Start Date": "05/19/2015 ",
        "End Date": "",
        "Rx Date": "06/01/2015 ",
        "Page": 33,
        "FIELD9": ""
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "Hypertension ",
        "Rx Name": "LOSARTAN/ HCTZ ",
        "Rx Type": "Angiotensin II Receptor Antagonist ",
        "Start Date": "05/23/2012 ",
        "End Date": "",
        "Rx Date": "06/01/2015 ",
        "Page": 159,
        "FIELD9": ""
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "N/A ",
        "Rx Name": "MULTAQ ",
        "Rx Type": "Class III Antiarrhythmics ",
        "Start Date": "05/12/2010 ",
        "End Date": "",
        "Rx Date": "06/01/2015 ",
        "Page": 33,
        "FIELD9": ""
      },
      {
        "Impairment Category": "Endocrine ",
        "Impairment": "Hypothyroidism ",
        "Rx Name": "SYNTHROID ",
        "Rx Type": "Hormone ",
        "Start Date": "05/20/2014 ",
        "End Date": "",
        "Rx Date": "06/01/2015 ",
        "Page": 33,
        "FIELD9": ""
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "Hyperlipidemia ",
        "Rx Name": "ZETIA ",
        "Rx Type": "Cholesterol Absorption Inhibitors ",
        "Start Date": "05/19/2015 ",
        "End Date": "",
        "Rx Date": "06/01/2015 ",
        "Page": 33,
        "FIELD9": ""
      },
      {
        "Impairment Category": "Lifestyle ",
        "Impairment": "N/A ",
        "Rx Name": "MULTIVITAMINS ",
        "Rx Type": "Vitamins ",
        "Start Date": "05/16/2013 ",
        "End Date": "",
        "Rx Date": "05/19/2015 ",
        "Page": 175,
        "FIELD9": ""
      },
      {
        "Impairment Category": "Lifestyle ",
        "Impairment": "N/A ",
        "Rx Name": "VITAMIN D2 ",
        "Rx Type": "Vitamin And Mineral Combinations ",
        "Start Date": "05/20/2014 ",
        "End Date": "",
        "Rx Date": "05/19/2015 ",
        "Page": 175,
        "FIELD9": ""
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "Hypertension ",
        "Rx Name": "HYZAAR ",
        "Rx Type": "Direct Vasodilators ",
        "Start Date": "03/17/2010 ",
        "End Date": "",
        "Rx Date": "05/28/2014 ",
        "Page": 37,
        "FIELD9": ""
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "Hypertension ",
        "Rx Name": "TOPROL-XL ",
        "Rx Type": "Beta-Adrenergic Blocking Agents ",
        "Start Date": "03/17/2010 ",
        "End Date": "",
        "Rx Date": "05/28/2014 ",
        "Page": 37,
        "FIELD9": ""
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "Hyperlipidemia ",
        "Rx Name": "VYTORIN ",
        "Rx Type": "Cholesterol Absorption Inhibitors ",
        "Start Date": "03/17/2010 ",
        "End Date": "",
        "Rx Date": "05/28/2014 ",
        "Page": 37,
        "FIELD9": ""
      },
      {
        "Impairment Category": "Lifestyle ",
        "Impairment": "N/A ",
        "Rx Name": "CENTRUM SILVER ",
        "Rx Type": "Vitamins ",
        "Start Date": "05/12/2010 ",
        "End Date": "",
        "Rx Date": "05/24/2013 ",
        "Page": 41,
        "FIELD9": ""
      },
      {
        "Impairment Category": "Endocrine ",
        "Impairment": "Hypothyroidism ",
        "Rx Name": "LEVOXYL ",
        "Rx Type": "Hormone ",
        "Start Date": "05/19/2011 ",
        "End Date": "",
        "Rx Date": "05/24/2013 ",
        "Page": 41,
        "FIELD9": ""
      },
      {
        "Impairment Category": "Lifestyle ",
        "Impairment": "N/A ",
        "Rx Name": "SAW PALMETTO ",
        "Rx Type": "Herbal Products ",
        "Start Date": "05/12/2010 ",
        "End Date": "",
        "Rx Date": "05/24/2013 ",
        "Page": 41,
        "FIELD9": ""
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "Hyperlipidemia ",
        "Rx Name": "LOVAZA ",
        "Rx Type": "Triglyceride-Lowering ",
        "Start Date": "05/12/2010 ",
        "End Date": "",
        "Rx Date": "05/19/2011 ",
        "Page": 49,
        "FIELD9": ""
      }
    ],
    "Test": [
      {
        "Impairment Category": "Lifestyle ",
        "Impairment": "N/A ",
        "Rx Name": "ALPRAZOLAM ",
        "Rx Type": "Benzodiazepines ",
        "Start Date": "05/19/2011 ",
        "End Date": "",
        "Rx Date": "06/01/2015 ",
        "Page": 33,
        "FIELD9": ""
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "N/A ",
        "Rx Name": "ASA ",
        "Rx Type": "NSAIDS ",
        "Start Date": "03/17/2010 ",
        "End Date": "",
        "Rx Date": "06/01/2015 ",
        "Page": 33,
        "FIELD9": ""
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "Hyperlipidemia ",
        "Rx Name": "ATORVASTATIN CALCIUM ",
        "Rx Type": "HMG CoA Reductase Inhibitors ",
        "Start Date": "05/19/2015 ",
        "End Date": "",
        "Rx Date": "06/01/2015 ",
        "Page": 33,
        "FIELD9": ""
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "Hypertension ",
        "Rx Name": "LOSARTAN/ HCTZ ",
        "Rx Type": "Angiotensin II Receptor Antagonist ",
        "Start Date": "05/23/2012 ",
        "End Date": "",
        "Rx Date": "06/01/2015 ",
        "Page": 159,
        "FIELD9": ""
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "N/A ",
        "Rx Name": "MULTAQ ",
        "Rx Type": "Class III Antiarrhythmics ",
        "Start Date": "05/12/2010 ",
        "End Date": "",
        "Rx Date": "06/01/2015 ",
        "Page": 33,
        "FIELD9": ""
      },
      {
        "Impairment Category": "Endocrine ",
        "Impairment": "Hypothyroidism ",
        "Rx Name": "SYNTHROID ",
        "Rx Type": "Hormone ",
        "Start Date": "05/20/2014 ",
        "End Date": "",
        "Rx Date": "06/01/2015 ",
        "Page": 33,
        "FIELD9": ""
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "Hyperlipidemia ",
        "Rx Name": "ZETIA ",
        "Rx Type": "Cholesterol Absorption Inhibitors ",
        "Start Date": "05/19/2015 ",
        "End Date": "",
        "Rx Date": "06/01/2015 ",
        "Page": 33,
        "FIELD9": ""
      },
      {
        "Impairment Category": "Lifestyle ",
        "Impairment": "N/A ",
        "Rx Name": "MULTIVITAMINS ",
        "Rx Type": "Vitamins ",
        "Start Date": "05/16/2013 ",
        "End Date": "",
        "Rx Date": "05/19/2015 ",
        "Page": 175,
        "FIELD9": ""
      },
      {
        "Impairment Category": "Lifestyle ",
        "Impairment": "N/A ",
        "Rx Name": "VITAMIN D2 ",
        "Rx Type": "Vitamin And Mineral Combinations ",
        "Start Date": "05/20/2014 ",
        "End Date": "",
        "Rx Date": "05/19/2015 ",
        "Page": 175,
        "FIELD9": ""
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "Hypertension ",
        "Rx Name": "HYZAAR ",
        "Rx Type": "Direct Vasodilators ",
        "Start Date": "03/17/2010 ",
        "End Date": "",
        "Rx Date": "05/28/2014 ",
        "Page": 37,
        "FIELD9": ""
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "Hypertension ",
        "Rx Name": "TOPROL-XL ",
        "Rx Type": "Beta-Adrenergic Blocking Agents ",
        "Start Date": "03/17/2010 ",
        "End Date": "",
        "Rx Date": "05/28/2014 ",
        "Page": 37,
        "FIELD9": ""
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "Hyperlipidemia ",
        "Rx Name": "VYTORIN ",
        "Rx Type": "Cholesterol Absorption Inhibitors ",
        "Start Date": "03/17/2010 ",
        "End Date": "",
        "Rx Date": "05/28/2014 ",
        "Page": 37,
        "FIELD9": ""
      },
      {
        "Impairment Category": "Lifestyle ",
        "Impairment": "N/A ",
        "Rx Name": "CENTRUM SILVER ",
        "Rx Type": "Vitamins ",
        "Start Date": "05/12/2010 ",
        "End Date": "",
        "Rx Date": "05/24/2013 ",
        "Page": 41,
        "FIELD9": ""
      },
      {
        "Impairment Category": "Endocrine ",
        "Impairment": "Hypothyroidism ",
        "Rx Name": "LEVOXYL ",
        "Rx Type": "Hormone ",
        "Start Date": "05/19/2011 ",
        "End Date": "",
        "Rx Date": "05/24/2013 ",
        "Page": 41,
        "FIELD9": ""
      },
      {
        "Impairment Category": "Lifestyle ",
        "Impairment": "N/A ",
        "Rx Name": "SAW PALMETTO ",
        "Rx Type": "Herbal Products ",
        "Start Date": "05/12/2010 ",
        "End Date": "",
        "Rx Date": "05/24/2013 ",
        "Page": 41,
        "FIELD9": ""
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "Hyperlipidemia ",
        "Rx Name": "LOVAZA ",
        "Rx Type": "Triglyceride-Lowering ",
        "Start Date": "05/12/2010 ",
        "End Date": "",
        "Rx Date": "05/19/2011 ",
        "Page": 49,
        "FIELD9": ""
      }
    ],
    "Labs": [
      {
        "Impairment Category": "Labs ",
        "Impairment": "CMP Panel ",
        "Feature Date": "05/19/2015 ",
        "Feature": "A/G Ratio ",
        "Value": "1.1",
        "Normal Range": "0.8-2.0 ",
        "Unit Of Measurement": "N/A ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "Normal "
        },
        "Page": 203
      },
      {
        "Impairment Category": "Endocrine ",
        "Impairment": "Prediabetes ",
        "Feature Date": "05/19/2015 ",
        "Feature": "A1c ",
        "Value": "6.2",
        "Normal Range": "4.0-6.0 ",
        "Unit Of Measurement": "% ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "High "
        },
        "Page": 203
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "CMP Panel ",
        "Feature Date": "05/19/2015 ",
        "Feature": "Albumin (Serum) ",
        "Value": "4",
        "Normal Range": "4.0-6.0 ",
        "Unit Of Measurement": "G/DL ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "Normal "
        },
        "Page": 203
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "CMP Panel ",
        "Feature Date": "05/19/2015 ",
        "Feature": "Alkaline Phosphatase (ALP Or AP) ",
        "Value": "61",
        "Normal Range": "30-120 ",
        "Unit Of Measurement": "IU/L ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "Normal "
        },
        "Page": 203
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "CMP Panel ",
        "Feature Date": "05/19/2015 ",
        "Feature": "ALT ",
        "Value": "21",
        "Normal Range": "0-35 ",
        "Unit Of Measurement": "IU/L ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "Normal "
        },
        "Page": 203
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "CMP Panel ",
        "Feature Date": "05/19/2015 ",
        "Feature": "AST ",
        "Value": "20",
        "Normal Range": "0-35 ",
        "Unit Of Measurement": "IU/L ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "Normal "
        },
        "Page": 203
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "CBC Panel ",
        "Feature Date": "05/19/2015 ",
        "Feature": "Basophils (ABC) ",
        "Value": "6",
        "Normal Range": "0-200 ",
        "Unit Of Measurement": "Cells/ML ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "Normal "
        },
        "Page": 204
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "CBC Panel ",
        "Feature Date": "05/19/2015 ",
        "Feature": "Basophils% ",
        "Value": "0.1",
        "Normal Range": "0-1 ",
        "Unit Of Measurement": "% ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "Normal "
        },
        "Page": 204
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "CMP Panel ",
        "Feature Date": "05/19/2015 ",
        "Feature": "Bilirubin ",
        "Value": "0.8",
        "Normal Range": "0-1.0 ",
        "Unit Of Measurement": "Umol/L ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "Normal "
        },
        "Page": 203
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "CMP Panel ",
        "Feature Date": "05/19/2015 ",
        "Feature": "Blood Creatinine ",
        "Value": "1.44",
        "Normal Range": "0.5-1.3 ",
        "Unit Of Measurement": "Mg/DL ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "High "
        },
        "Page": 203
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "CMP Panel ",
        "Feature Date": "05/19/2015 ",
        "Feature": "Blood Urea, Or Blood Urea Nitrogen (BUN) ",
        "Value": "19",
        "Normal Range": "7.0-25.0 ",
        "Unit Of Measurement": "Mg/DL ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "Normal "
        },
        "Page": 203
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "CMP Panel ",
        "Feature Date": "05/19/2015 ",
        "Feature": "BUN/Creatinine ",
        "Value": "13",
        "Normal Range": "6.0-22.0 ",
        "Unit Of Measurement": "Mg/DL ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "Normal "
        },
        "Page": 203
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "CMP Panel ",
        "Feature Date": "05/19/2015 ",
        "Feature": "Calcium ",
        "Value": "9.4",
        "Normal Range": "8.6- 10.2 ",
        "Unit Of Measurement": "Mg/DL ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "Normal "
        },
        "Page": 203
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "CMP Panel ",
        "Feature Date": "05/19/2015 ",
        "Feature": "Carbon Dioxide ",
        "Value": "29",
        "Normal Range": "16-30 ",
        "Unit Of Measurement": "MEq/L ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "Normal "
        },
        "Page": 203
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "CMP Panel ",
        "Feature Date": "05/19/2015 ",
        "Feature": "Chloride ",
        "Value": "102",
        "Normal Range": "98-106 ",
        "Unit Of Measurement": "MEq/L ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "Normal "
        },
        "Page": 203
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "CMP Panel ",
        "Feature Date": "05/19/2015 ",
        "Feature": "EGFR-AA ",
        "Value": "55",
        "Normal Range": ">60 ",
        "Unit Of Measurement": "ML/Min/1.73 M^2 ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "Low "
        },
        "Page": 203
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "CMP Panel ",
        "Feature Date": "05/19/2015 ",
        "Feature": "EGFR-NAA ",
        "Value": "47",
        "Normal Range": ">60 ",
        "Unit Of Measurement": "ML/Min/1.73 M^2 ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "Low "
        },
        "Page": 203
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "CBC Panel ",
        "Feature Date": "05/19/2015 ",
        "Feature": "Eosinophils (AEC) ",
        "Value": "215",
        "Normal Range": "15-500 ",
        "Unit Of Measurement": "Cells/ML ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "Normal "
        },
        "Page": 204
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "CBC Panel ",
        "Feature Date": "05/19/2015 ",
        "Feature": "Eosinophils% ",
        "Value": "3.7",
        "Normal Range": "N/A ",
        "Unit Of Measurement": "% ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "Normal "
        },
        "Page": 204
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "Hypothyroidism ",
        "Feature Date": "05/19/2015 ",
        "Feature": "Free Thyroxine (Free T4) ",
        "Value": "1.3",
        "Normal Range": "0.8-2.8 ",
        "Unit Of Measurement": "Ng/DL ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "Normal "
        },
        "Page": 203
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "CMP Panel ",
        "Feature Date": "05/19/2015 ",
        "Feature": "Globulin ",
        "Value": "3.6",
        "Normal Range": "2.6-4.6 ",
        "Unit Of Measurement": "G/DL ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "Normal "
        },
        "Page": 203
      },
      {
        "Impairment Category": "Endocrine ",
        "Impairment": "Prediabetes ",
        "Feature Date": "05/19/2015 ",
        "Feature": "Glucose ",
        "Value": "129",
        "Normal Range": "65-99 ",
        "Unit Of Measurement": "Mg/DL ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "High "
        },
        "Page": 203
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "Hyperlipidemia ",
        "Feature Date": "05/19/2015 ",
        "Feature": "HDL ",
        "Value": "40",
        "Normal Range": "40-75 ",
        "Unit Of Measurement": "Mg/DL ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "Normal "
        },
        "Page": 200
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "CBC Panel ",
        "Feature Date": "05/19/2015 ",
        "Feature": "Hematocrit (HCT) ",
        "Value": "49.4",
        "Normal Range": "35.0- 45.0 ",
        "Unit Of Measurement": "% ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "Normal "
        },
        "Page": 204
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "CBC Panel ",
        "Feature Date": "05/19/2015 ",
        "Feature": "Hemoglobin (HGB) ",
        "Value": "15.9",
        "Normal Range": "13.6- 17.0 ",
        "Unit Of Measurement": "G/DL ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "Normal "
        },
        "Page": 204
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "Hyperlipidemia ",
        "Feature Date": "05/19/2015 ",
        "Feature": "LDL ",
        "Value": "54",
        "Normal Range": "50-130 ",
        "Unit Of Measurement": "Mg/DL ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "Normal "
        },
        "Page": 200
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "CBC Panel ",
        "Feature Date": "05/19/2015 ",
        "Feature": "Lymphocytes (ALC) ",
        "Value": "887",
        "Normal Range": "850- 3900 ",
        "Unit Of Measurement": "Cells/ML ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "Normal "
        },
        "Page": 204
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "CBC Panel ",
        "Feature Date": "05/19/2015 ",
        "Feature": "Lymphocytes% ",
        "Value": "15.3",
        "Normal Range": "N/A ",
        "Unit Of Measurement": "% ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "Normal "
        },
        "Page": 204
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "CBC Panel ",
        "Feature Date": "05/19/2015 ",
        "Feature": "MCH ",
        "Value": "28.5",
        "Normal Range": "26.0- 32.0 ",
        "Unit Of Measurement": "Pg ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "Normal "
        },
        "Page": 204
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "CBC Panel ",
        "Feature Date": "05/19/2015 ",
        "Feature": "MCHC ",
        "Value": "32.1",
        "Normal Range": "32.0- 36.0 ",
        "Unit Of Measurement": "G/DL ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "Normal "
        },
        "Page": 204
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "CBC Panel ",
        "Feature Date": "05/19/2015 ",
        "Feature": "MCV ",
        "Value": "88.6",
        "Normal Range": "80.0- 94.0 ",
        "Unit Of Measurement": "FL ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "Normal "
        },
        "Page": 204
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "CBC Panel ",
        "Feature Date": "05/19/2015 ",
        "Feature": "Monocytes ",
        "Value": "510",
        "Normal Range": "200-950 ",
        "Unit Of Measurement": "Cells/ML ",
        "Clinician Name": "Robert J ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "Normal "
        },
        "Page": 204
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "CBC Panel ",
        "Feature Date": "05/19/2015 ",
        "Feature": "MPV ",
        "Value": "9.2",
        "Normal Range": "7.5-11.2 ",
        "Unit Of Measurement": "FL ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "Normal "
        },
        "Page": 204
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "CBC Panel ",
        "Feature Date": "05/19/2015 ",
        "Feature": "Neutrophils (ANC) ",
        "Value": "4182",
        "Normal Range": "1500- 7800 ",
        "Unit Of Measurement": "Cells/ML ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "Normal "
        },
        "Page": 204
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "CBC Panel ",
        "Feature Date": "05/19/2015 ",
        "Feature": "Neutrophils% ",
        "Value": "72.1",
        "Normal Range": "N/A ",
        "Unit Of Measurement": "% ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "Normal "
        },
        "Page": 204
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "CBC Panel ",
        "Feature Date": "05/19/2015 ",
        "Feature": "Platelet Count ",
        "Value": "217",
        "Normal Range": "150-450 ",
        "Unit Of Measurement": "10*3/UL ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "Normal "
        },
        "Page": 204
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "CMP Panel ",
        "Feature Date": "05/19/2015 ",
        "Feature": "Potassium ",
        "Value": "4.1",
        "Normal Range": "3.5-5.0 ",
        "Unit Of Measurement": "MEq/L ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "Normal "
        },
        "Page": 203
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "CBC Panel ",
        "Feature Date": "05/19/2015 ",
        "Feature": "RBC ",
        "Value": "5.58",
        "Normal Range": "4.5-5.7 ",
        "Unit Of Measurement": "10*6/UL ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "Normal "
        },
        "Page": 203
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "CBC Panel ",
        "Feature Date": "05/19/2015 ",
        "Feature": "RDW ",
        "Value": "14.5",
        "Normal Range": "11.5- 14.5 ",
        "Unit Of Measurement": "% ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "Normal "
        },
        "Page": 204
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "CMP Panel ",
        "Feature Date": "05/19/2015 ",
        "Feature": "Sodium ",
        "Value": "139",
        "Normal Range": "136-145 ",
        "Unit Of Measurement": "Mmol/L ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "Normal "
        },
        "Page": 203
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "Hyperlipidemia ",
        "Feature Date": "05/19/2015 ",
        "Feature": "Total Cholesterol ",
        "Value": "133",
        "Normal Range": "60-200 ",
        "Unit Of Measurement": "Mg/DL ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "Normal "
        },
        "Page": 200
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "Hyperlipidemia ",
        "Feature Date": "05/19/2015 ",
        "Feature": "Total Cholesterol/HDL- C Ratio ",
        "Value": "3.325",
        "Normal Range": "<5.0 ",
        "Unit Of Measurement": "N/A ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "Normal "
        },
        "Page": 200
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "CMP Panel ",
        "Feature Date": "05/19/2015 ",
        "Feature": "Total Protein ",
        "Value": "7.6",
        "Normal Range": "6.0-8.0 ",
        "Unit Of Measurement": "G/DL ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "Normal "
        },
        "Page": 203
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "Hyperlipidemia ",
        "Feature Date": "05/19/2015 ",
        "Feature": "Triglycerides ",
        "Value": "164",
        "Normal Range": "0-150 ",
        "Unit Of Measurement": "Mg/DL ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "High "
        },
        "Page": 200
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "Hypothyroidism ",
        "Feature Date": "05/19/2015 ",
        "Feature": "TSH ",
        "Value": "2.06",
        "Normal Range": "0.5-4.5 ",
        "Unit Of Measurement": "MIU/L ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "Normal "
        },
        "Page": 203
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "N/A ",
        "Feature Date": "05/19/2015 ",
        "Feature": "Urine Protein ",
        "Value": "Negative ",
        "Normal Range": "Negative ",
        "Unit Of Measurement": "Mg/DL ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "Negative "
        },
        "Page": 204
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "N/A ",
        "Feature Date": "05/19/2015 ",
        "Feature": "Vitamin B12 ",
        "Value": "542",
        "Normal Range": "190-950 ",
        "Unit Of Measurement": "Pg/ML ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "Normal "
        },
        "Page": 204
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "N/A ",
        "Feature Date": "05/19/2015 ",
        "Feature": "Vitamin D ",
        "Value": "26",
        "Normal Range": "30-100 ",
        "Unit Of Measurement": "Ng/ML ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "Low "
        },
        "Page": 205
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "CBC Panel ",
        "Feature Date": "05/19/2015 ",
        "Feature": "WBC Count ",
        "Value": "5.8",
        "Normal Range": "4.5-11.0 ",
        "Unit Of Measurement": "10*3/UL ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "Normal "
        },
        "Page": 203
      },
      {
        "Impairment Category": "Endocrine ",
        "Impairment": "Prediabetes ",
        "Feature Date": "11/18/2014 ",
        "Feature": "A1c ",
        "Value": "6.2",
        "Normal Range": "4.0-6.0 ",
        "Unit Of Measurement": "% ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "High "
        },
        "Page": 206
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "Hyperlipidemia ",
        "Feature Date": "11/18/2014 ",
        "Feature": "LDL ",
        "Value": "191",
        "Normal Range": "50-130 ",
        "Unit Of Measurement": "Mg/DL ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "High "
        },
        "Page": 206
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "CMP Panel ",
        "Feature Date": "09/29/2014 ",
        "Feature": "Blood Urea, Or Blood Urea Nitrogen (BUN) ",
        "Value": "23",
        "Normal Range": "7.0-25.0 ",
        "Unit Of Measurement": "Mg/DL ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "High "
        },
        "Page": 207
      },
      {
        "Impairment Category": "Endocrine ",
        "Impairment": "Prediabetes ",
        "Feature Date": "06/18/2014 ",
        "Feature": "Glucose ",
        "Value": "107",
        "Normal Range": "65-99 ",
        "Unit Of Measurement": "Mg/DL ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "High "
        },
        "Page": 207
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "CMP Panel ",
        "Feature Date": "05/20/2014 ",
        "Feature": "Blood Creatinine ",
        "Value": "1.7",
        "Normal Range": "0.5-1.3 ",
        "Unit Of Measurement": "Mg/DL ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "High "
        },
        "Page": 207
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "CMP Panel ",
        "Feature Date": "05/20/2014 ",
        "Feature": "Blood Urea, Or Blood Urea Nitrogen (BUN) ",
        "Value": "29",
        "Normal Range": "7.0-25.0 ",
        "Unit Of Measurement": "Mg/DL ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "High "
        },
        "Page": 207
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "Hyperlipidemia ",
        "Feature Date": "05/20/2014 ",
        "Feature": "HDL ",
        "Value": "38",
        "Normal Range": "40-75 ",
        "Unit Of Measurement": "Mg/DL ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "Low "
        },
        "Page": 213
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "Hyperlipidemia ",
        "Feature Date": "05/20/2014 ",
        "Feature": "Triglycerides ",
        "Value": "185",
        "Normal Range": "0-150 ",
        "Unit Of Measurement": "Mg/DL ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "High "
        },
        "Page": 213
      },
      {
        "Impairment Category": "Cancer ",
        "Impairment": "Prostate Cancer ",
        "Feature Date": "05/01/2014",
        "Feature": "Total PSA ",
        "Value": "1.8",
        "Normal Range": "0.0-4.0 ",
        "Unit Of Measurement": "Ng/ML ",
        "Clinician Name": "****** MD ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "Normal "
        },
        "Page": 33
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "CMP Panel ",
        "Feature Date": "11/19/2013 ",
        "Feature": "Blood Urea, Or Blood Urea Nitrogen (BUN) ",
        "Value": "23",
        "Normal Range": "7.0-25.0 ",
        "Unit Of Measurement": "Mg/DL ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "High "
        },
        "Page": 207
      },
      {
        "Impairment Category": "Endocrine ",
        "Impairment": "Prediabetes ",
        "Feature Date": "11/19/2013 ",
        "Feature": "Glucose ",
        "Value": "119",
        "Normal Range": "65-99 ",
        "Unit Of Measurement": "Mg/DL ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "High "
        },
        "Page": 207
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "Hyperlipidemia ",
        "Feature Date": "11/19/2013 ",
        "Feature": "Total Cholesterol/HDL C Ratio ",
        "Value": "3.4",
        "Normal Range": "4.2-7.0 ",
        "Unit Of Measurement": "N/A ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "Low "
        },
        "Page": 208
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "CMP Panel ",
        "Feature Date": "10/01/2013",
        "Feature": "Blood Creatinine ",
        "Value": "1.6",
        "Normal Range": "0.5-1.3 ",
        "Unit Of Measurement": "Mg/DL ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "High "
        },
        "Page": 207
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "CMP Panel ",
        "Feature Date": "10/01/2013",
        "Feature": "Blood Urea, Or Blood Urea Nitrogen (BUN) ",
        "Value": "31",
        "Normal Range": "7.0-25.0 ",
        "Unit Of Measurement": "Mg/DL ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "High "
        },
        "Page": 207
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "Hyperlipidemia ",
        "Feature Date": "09/26/2013 ",
        "Feature": "HDL ",
        "Value": "36",
        "Normal Range": "40-75 ",
        "Unit Of Measurement": "Mg/DL ",
        "Clinician Name": "Unspecified ",
        "Clinician Specialty": "Unspecified ",
        "Result Evaluation": {
          "Flag": "Low "
        },
        "Page": 22
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "CMP Panel ",
        "Feature Date": "05/16/2013 ",
        "Feature": "Blood Urea, Or Blood Urea Nitrogen (BUN) ",
        "Value": "28",
        "Normal Range": "7.0-25.0 ",
        "Unit Of Measurement": "Mg/DL ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "High "
        },
        "Page": 207
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "Hyperlipidemia ",
        "Feature Date": "05/16/2013 ",
        "Feature": "HDL ",
        "Value": "39",
        "Normal Range": "40-75 ",
        "Unit Of Measurement": "Mg/DL ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "Low "
        },
        "Page": 234
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "CBC Panel ",
        "Feature Date": "05/16/2013 ",
        "Feature": "MCHC ",
        "Value": "31",
        "Normal Range": "32.0- 36.0 ",
        "Unit Of Measurement": "G/DL ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "Low "
        },
        "Page": 207
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "N/A ",
        "Feature Date": "05/16/2013 ",
        "Feature": "Vitamin D ",
        "Value": "28",
        "Normal Range": "30-100 ",
        "Unit Of Measurement": "Ng/ML ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "Low "
        },
        "Page": 230
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "CBC Panel ",
        "Feature Date": "05/16/2013 ",
        "Feature": "WBC Count ",
        "Value": "4.1",
        "Normal Range": "4.5-11.0 ",
        "Unit Of Measurement": "10*3/UL ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "Low "
        },
        "Page": 207
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "CMP Panel ",
        "Feature Date": "11/14/2012 ",
        "Feature": "Blood Creatinine ",
        "Value": "1.6",
        "Normal Range": "0.5-1.3 ",
        "Unit Of Measurement": "Mg/DL ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "High "
        },
        "Page": 210
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "CMP Panel ",
        "Feature Date": "11/14/2012 ",
        "Feature": "Blood Urea, Or Blood Urea Nitrogen (BUN) ",
        "Value": "29",
        "Normal Range": "7.0-25.0 ",
        "Unit Of Measurement": "Mg/DL ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "High "
        },
        "Page": 210
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "Hyperlipidemia ",
        "Feature Date": "11/14/2012 ",
        "Feature": "Total Cholesterol/HDL- C Ratio ",
        "Value": "2.8",
        "Normal Range": "4.2-7.0 ",
        "Unit Of Measurement": "N/A ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "Low "
        },
        "Page": 211
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "CMP Panel ",
        "Feature Date": "10/16/2012 ",
        "Feature": "Blood Creatinine ",
        "Value": "1.5",
        "Normal Range": "0.5-1.3 ",
        "Unit Of Measurement": "Mg/DL ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "High "
        },
        "Page": 220
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "CMP Panel ",
        "Feature Date": "10/16/2012 ",
        "Feature": "Blood Urea, Or Blood Urea Nitrogen (BUN) ",
        "Value": "27",
        "Normal Range": "7.0-25.0 ",
        "Unit Of Measurement": "Mg/DL ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "High "
        },
        "Page": 220
      },
      {
        "Impairment Category": "Endocrine ",
        "Impairment": "Prediabetes ",
        "Feature Date": "10/16/2012 ",
        "Feature": "Glucose ",
        "Value": "148",
        "Normal Range": "65-99 ",
        "Unit Of Measurement": "Mg/DL ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "High "
        },
        "Page": 220
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "CMP Panel ",
        "Feature Date": "05/13/2012 ",
        "Feature": "Blood Urea, Or Blood Urea Nitrogen (BUN) ",
        "Value": "21",
        "Normal Range": "7.0-25.0 ",
        "Unit Of Measurement": "Mg/DL ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "High "
        },
        "Page": 223
      },
      {
        "Impairment Category": "Endocrine ",
        "Impairment": "Prediabetes ",
        "Feature Date": "05/13/2012 ",
        "Feature": "Glucose ",
        "Value": "114",
        "Normal Range": "65-99 ",
        "Unit Of Measurement": "Mg/DL ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "High "
        },
        "Page": 223
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "CMP Panel ",
        "Feature Date": "11/16/2011 ",
        "Feature": "Blood Urea, Or Blood Urea Nitrogen (BUN) ",
        "Value": "22",
        "Normal Range": "7.0-25.0 ",
        "Unit Of Measurement": "Mg/DL ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "High "
        },
        "Page": 226
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "Hyperlipidemia ",
        "Feature Date": "11/16/2011 ",
        "Feature": "Total Cholesterol/HDL- C Ratio ",
        "Value": "3.4",
        "Normal Range": "4.2-7.0 ",
        "Unit Of Measurement": "N/A ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "Low "
        },
        "Page": 227
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "CMP Panel ",
        "Feature Date": "05/18/2011 ",
        "Feature": "Blood Urea, Or Blood Urea Nitrogen (BUN) ",
        "Value": "26",
        "Normal Range": "7.0-25.0 ",
        "Unit Of Measurement": "Mg/DL ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "High "
        },
        "Page": 231
      },
      {
        "Impairment Category": "Endocrine ",
        "Impairment": "Prediabetes ",
        "Feature Date": "05/18/2011 ",
        "Feature": "Glucose ",
        "Value": "107",
        "Normal Range": "65-99 ",
        "Unit Of Measurement": "Mg/DL ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "High "
        },
        "Page": 231
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "Hypothyroidism ",
        "Feature Date": "01/31/2011 ",
        "Feature": "TSH ",
        "Value": "28.45",
        "Normal Range": "0.5-4.5 ",
        "Unit Of Measurement": "MIU/L ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "High "
        },
        "Page": 265
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "CMP Panel ",
        "Feature Date": "11/16/2010 ",
        "Feature": "Blood Urea, Or Blood Urea Nitrogen (BUN) ",
        "Value": "23",
        "Normal Range": "7.0-25.0 ",
        "Unit Of Measurement": "Mg/DL ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "High "
        },
        "Page": 241
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "N/A ",
        "Feature Date": "11/16/2010 ",
        "Feature": "Lipase ",
        "Value": "112",
        "Normal Range": "7-60 ",
        "Unit Of Measurement": "U/L ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "High "
        },
        "Page": 266
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "Hyperlipidemia ",
        "Feature Date": "11/16/2010 ",
        "Feature": "Total Cholesterol/HDL C Ratio ",
        "Value": "3.5",
        "Normal Range": "4.2-7.0 ",
        "Unit Of Measurement": "N/A ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "Low "
        },
        "Page": 242
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "Hypothyroidism ",
        "Feature Date": "11/16/2010 ",
        "Feature": "TSH ",
        "Value": "0.25",
        "Normal Range": "0.5-4.5 ",
        "Unit Of Measurement": "MIU/L ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "Low "
        },
        "Page": 247
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "Hypothyroidism ",
        "Feature Date": "09/30/2010 ",
        "Feature": "Free Thyroxine (Free T4) ",
        "Value": "2.2",
        "Normal Range": "0.8-2.8 ",
        "Unit Of Measurement": "Ng/DL ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "High "
        },
        "Page": 247
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "N/A ",
        "Feature Date": "09/30/2010 ",
        "Feature": "Lipase ",
        "Value": "97",
        "Normal Range": "7-60 ",
        "Unit Of Measurement": "U/L ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "High "
        },
        "Page": 267
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "Hypothyroidism ",
        "Feature Date": "09/30/2010 ",
        "Feature": "TSH ",
        "Value": "0",
        "Normal Range": "0.5-4.5 ",
        "Unit Of Measurement": "MIU/L ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "Low "
        },
        "Page": 247
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "CMP Panel ",
        "Feature Date": "09/14/2010 ",
        "Feature": "ALT ",
        "Value": "50",
        "Normal Range": "0-35 ",
        "Unit Of Measurement": "IU/L ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "High "
        },
        "Page": 254
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "Hypothyroidism ",
        "Feature Date": "09/14/2010 ",
        "Feature": "Free Thyroxine (Free T4) ",
        "Value": "15.3",
        "Normal Range": "0.8-2.8 ",
        "Unit Of Measurement": "Ng/DL ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "High "
        },
        "Page": 254
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "N/A ",
        "Feature Date": "09/14/2010 ",
        "Feature": "Lipase ",
        "Value": "87",
        "Normal Range": "10-140 ",
        "Unit Of Measurement": "U/L ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "High "
        },
        "Page": 271
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "Hypothyroidism ",
        "Feature Date": "09/14/2010 ",
        "Feature": "TSH ",
        "Value": "0.01",
        "Normal Range": "0.5-4.5 ",
        "Unit Of Measurement": "MIU/L ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "Low "
        },
        "Page": 254
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "CMP Panel ",
        "Feature Date": "09/08/2010",
        "Feature": "ALT ",
        "Value": "58",
        "Normal Range": "0-35 ",
        "Unit Of Measurement": "IU/L ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "High "
        },
        "Page": 258
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "Hypothyroidism ",
        "Feature Date": "09/08/2010",
        "Feature": "Free Thyroxine (Free T4) ",
        "Value": "16.2",
        "Normal Range": "0.8-2.8 ",
        "Unit Of Measurement": "Ng/DL ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "High "
        },
        "Page": 258
      },
      {
        "Impairment Category": "Endocrine ",
        "Impairment": "Prediabetes ",
        "Feature Date": "09/08/2010",
        "Feature": "Glucose ",
        "Value": "133",
        "Normal Range": "65-99 ",
        "Unit Of Measurement": "Mg/DL ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "High "
        },
        "Page": 257
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "N/A ",
        "Feature Date": "09/08/2010",
        "Feature": "Lipase ",
        "Value": "97",
        "Normal Range": "10-140 ",
        "Unit Of Measurement": "U/L ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "High "
        },
        "Page": 272
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "CBC Panel ",
        "Feature Date": "09/08/2010",
        "Feature": "MCH ",
        "Value": "26.9",
        "Normal Range": "27-32.0 ",
        "Unit Of Measurement": "Pg ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "Low "
        },
        "Page": 257
      },
      {
        "Impairment Category": "Labs ",
        "Impairment": "Hypothyroidism ",
        "Feature Date": "09/08/2010",
        "Feature": "TSH ",
        "Value": "0",
        "Normal Range": "0.5-4.5 ",
        "Unit Of Measurement": "MIU/L ",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Result Evaluation": {
          "Flag": "Low "
        },
        "Page": 258
      }
    ],
    "Lifestyle": [
      {
        "Impairment Category": "N/A ",
        "Impairment": "N/A ",
        "Report Date": "06/16/2015 ",
        "Event Feature Date": "Findings/Impression/Conclusion ",
        "Value": "nodules ",
        "Expanded Value": "Type: Ultrasound, Location: Neck, Indication: Possible enlargement of left lobe thyroid nodule based on recent thyroid sonogram, Findings/Impression/Conclusion: Small left lobe nodule ",
        "Page": 273
      },
      {
        "Impairment Category": "N/A ",
        "Impairment": "N/A ",
        "Report Date": "06/16/2015 ",
        "Event Feature Date": "Findings/Impression/Conclusior ",
        "Value": "isoechoic ",
        "Expanded Value": "Type: Ultrasound, Location: Neck, Indication: Possible enlargement of left lobe thyroid nodule based on recent thyroid sonogram, Findings/Impression/Conclusion: It is predominantly solid, hypertrophy isoechoic, has a peripheral halo ",
        "Page": 273
      },
      {
        "Impairment Category": "N/A ",
        "Impairment": "N/A ",
        "Report Date": "06/16/2015 ",
        "Event Feature Date": "Findings/Impression/Conclusion ",
        "Value": "cyst(s)-type ",
        "Expanded Value": "Type: Ultrasound, Location: Neck, Indication: Possible enlargement of left lobe thyroid nodule based on recent thyroid sonogram, Findings/Impression/Conclusion: Scattered small cystic components ",
        "Page": 273
      },
      {
        "Impairment Category": "N/A ",
        "Impairment": "N/A ",
        "Report Date": "06/16/2015 ",
        "Event Feature Date": "Findings/Impression/Conclusion ",
        "Value": "benign findings ",
        "Expanded Value": "Type: Ultrasound, Location: Neck, Indication: Possible enlargement of left lobe thyroid nodule based on recent thyroid sonogram, Findings/Impression/Conclusion: Overall, is has a benign imaging appearance ",
        "Page": 273
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "Hypertension ",
        "Report Date": "06/01/2015",
        "Event Feature Date": "Blood pressure ",
        "Value": "122/69 ",
        "Expanded Value": "Blood pressure 122/69, noted in vitals ",
        "Page": 34
      },
      {
        "Impairment Category": "Basic ",
        "Impairment": "BMI ",
        "Report Date": "06/01/2015",
        "Event Feature Date": "BMI ",
        "Value": "23.29",
        "Expanded Value": "BMI- 23.29, noted in vitals ",
        "Page": 34
      },
      {
        "Impairment Category": "Basic ",
        "Impairment": "Height ",
        "Report Date": "06/01/2015",
        "Event Feature Date": "Height ",
        "Value": "69.5",
        "Expanded Value": "Height- 69.5 inches, noted in vitals ",
        "Page": 34
      },
      {
        "Impairment Category": "Neurological ",
        "Impairment": "N/A ",
        "Report Date": "06/01/2015",
        "Event Feature Date": "Orientation to person ",
        "Value": "Yes ",
        "Expanded Value": "Oriented to person, noted in physical exam ",
        "Page": 34
      },
      {
        "Impairment Category": "Neurological ",
        "Impairment": "N/A ",
        "Report Date": "06/01/2015",
        "Event Feature Date": "Orientation to place ",
        "Value": "Yes ",
        "Expanded Value": "Oriented to place, noted in physical exam ",
        "Page": 34
      },
      {
        "Impairment Category": "Neurological ",
        "Impairment": "N/A ",
        "Report Date": "06/01/2015",
        "Event Feature Date": "Orientation to time ",
        "Value": "Yes ",
        "Expanded Value": "Oriented to time, noted in physical exam ",
        "Page": 34
      },
      {
        "Impairment Category": "Basic ",
        "Impairment": "Weight ",
        "Report Date": "06/01/2015",
        "Event Feature Date": "Weight ",
        "Value": "160",
        "Expanded Value": "Weight- 160 lbs, noted in vitals ",
        "Page": 34
      },
      {
        "Impairment Category": "N/A ",
        "Impairment": "N/A ",
        "Report Date": "05/26/2015 ",
        "Event Feature Date": "Findings/Impression/Conclusion ",
        "Value": "nodules ",
        "Expanded Value": "Type: Ultrasound, Location: Neck, Indication: Thyroid nodules, Findings/Impression/Conclusion: Bilateral thyroid nodules the largest now present within the lower pole the left which on prior examination had cystic present ",
        "Page": 274
      },
      {
        "Impairment Category": "N/A ",
        "Impairment": "N/A ",
        "Report Date": "05/26/2015 ",
        "Event Feature Date": "Findings/Impression/Conclusion ",
        "Value": "nodules ",
        "Expanded Value": "Type: Ultrasound, Location: Neck, Indication: Thyroid nodules, Findings/Impression/Conclusion: An additional 3 mm nodule noted within the upper pole, Let lobe itself measures 4.3X 1.2X1.8 cm, The right lobe measures 4.8X 1.4X1.9 cm it contains 2 solid nodules ",
        "Page": 274
      },
      {
        "Impairment Category": "Gastrointestinal ",
        "Impairment": "N/A ",
        "Report Date": "05/26/2015 ",
        "Event Feature Date": "Findings/Impression/Conclusion ",
        "Value": "N/A ",
        "Expanded Value": "Type: Ultrasound, Location: Abdomen, Indication: Distal abdominal aortic dissection, Findings/Impression/Conclusion: Grossly unchanged distal abdominal aortic dissection extending into the right common iliac artery ",
        "Page": 275
      },
      {
        "Impairment Category": "Gastrointestinal ",
        "Impairment": "N/A ",
        "Report Date": "05/26/2015 ",
        "Event Feature Date": "Findings/Impression/Conclusior ",
        "Value": "normal findings ",
        "Expanded Value": "Type: Ultrasound, Location: Abdomen, Indication: Distal abdominal aortic dissection, Findings/Impression/Conclusion: Distal aorta is normal in caliber measuring 2.3X2.1cm ",
        "Page": 275
      },
      {
        "Impairment Category": "Gastrointestinal ",
        "Impairment": "N/A ",
        "Report Date": "05/26/2015 ",
        "Event Feature Date": "Findings/Impression/Conclusion ",
        "Value": "atherosclerosis ",
        "Expanded Value": "Type: Ultrasound, Location: Abdomen, Indication: Distal abdominal aortic dissection, Findings/Impression/Conclusion: It is atherosclerotic ",
        "Page": 275
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "Hypertension ",
        "Report Date": "05/19/2015 ",
        "Event Feature Date": "Blood pressure ",
        "Value": "132/76 ",
        "Expanded Value": "Blood pressure 132/76, noted in vitals ",
        "Page": 175
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "Hypertension ",
        "Report Date": "05/19/2015 ",
        "Event Feature Date": "Hypertension diagnosed ",
        "Value": "Yes ",
        "Expanded Value": "Hypertension- well controlled, noted in assessment ",
        "Page": 176
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "Hypertension ",
        "Report Date": "11/18/2014 ",
        "Event Feature Date": "Blood pressure ",
        "Value": "115/60 ",
        "Expanded Value": "Blood pressure 115/60, noted in vitals ",
        "Page": 177
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "N/A ",
        "Report Date": "11/18/2014 ",
        "Event Feature Date": "Pulse ",
        "Value": "60",
        "Expanded Value": "Pulse- 60, noted in vitals ",
        "Page": 177
      },
      {
        "Impairment Category": "Basic ",
        "Impairment": "Weight ",
        "Report Date": "11/18/2014 ",
        "Event Feature Date": "Weight ",
        "Value": "167",
        "Expanded Value": "Weight- 167 lbs, noted in vitals ",
        "Page": 177
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "Hypertension ",
        "Report Date": "09/29/2014 ",
        "Event Feature Date": "Blood pressure ",
        "Value": "152/84 ",
        "Expanded Value": "Blood pressure 152/84, noted in vitals ",
        "Page": 178
      },
      {
        "Impairment Category": "Pulmonary ",
        "Impairment": "N/A ",
        "Report Date": "09/29/2014 ",
        "Event Feature Date": "CXR Findings ",
        "Value": "pacemaker seen ",
        "Expanded Value": "There is left subclavian pacemaker defibrillator with leads overlying the right atrium and right ventricle ",
        "Page": 278
      },
      {
        "Impairment Category": "Pulmonary ",
        "Impairment": "N/A ",
        "Report Date": "09/29/2014 ",
        "Event Feature Date": "CXR Findings ",
        "Value": "cardiopulmonary disease ",
        "Expanded Value": "No pneumothorax ",
        "Page": 278
      },
      {
        "Impairment Category": "Pulmonary ",
        "Impairment": "N/A ",
        "Report Date": "09/29/2014 ",
        "Event Feature Date": "SPO2, oxygen level, oxygen saturation, nadir ",
        "Value": "97",
        "Expanded Value": "SPO2-97%, noted in vitals ",
        "Page": 178
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "Hypertension ",
        "Report Date": "05/28/2014 ",
        "Event Feature Date": "Blood pressure ",
        "Value": "134/83 ",
        "Expanded Value": "Blood pressure 134/83, noted in vitals ",
        "Page": 37
      },
      {
        "Impairment Category": "N/A ",
        "Impairment": "N/A ",
        "Report Date": "05/28/2014 ",
        "Event Feature Date": "Findings/Impression/Conclusion ",
        "Value": "nodules ",
        "Expanded Value": "Type: Ultrasound, Location: Neck, Indication: Nodules, Findings/Impression/Conclusion: Stable thyroid nodules ",
        "Page": 279
      },
      {
        "Impairment Category": "N/A ",
        "Impairment": "N/A ",
        "Report Date": "05/28/2014 ",
        "Event Feature Date": "Findings/Impression/Conclusion ",
        "Value": "no significant interval changes ",
        "Expanded Value": "Type: Ultrasound, Location: Neck, Indication: Nodules, Findings/Impression/Conclusion: They have not changed significantly in size nor in number ",
        "Page": 279
      },
      {
        "Impairment Category": "N/A ",
        "Impairment": "N/A ",
        "Report Date": "05/28/2014 ",
        "Event Feature Date": "Findings/Impression/Conclusion ",
        "Value": "N/A ",
        "Expanded Value": "Type: Ultrasound, Location: Neck, Indication: Nodules, Findings/Impression/Conclusion: Largest on the right is present the lower lobe measuring approximately 7mm, largest on the left is complex and measures approximately 6mm ",
        "Page": 279
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "Hypertension ",
        "Report Date": "05/20/2014 ",
        "Event Feature Date": "Blood pressure ",
        "Value": "142/84 ",
        "Expanded Value": "Blood pressure 142/84, noted in vitals ",
        "Page": 180
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "Hypertension ",
        "Report Date": "11/21/2013 ",
        "Event Feature Date": "Blood pressure ",
        "Value": "130/70 ",
        "Expanded Value": "Blood pressure 130/70, noted in vitals ",
        "Page": 3
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "Hypertension ",
        "Report Date": "11/21/2013 ",
        "Event Feature Date": "Hypertension diagnosed ",
        "Value": "Yes ",
        "Expanded Value": "Hypertension, benign, noted in assessment ",
        "Page": 1
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "Hypertension ",
        "Report Date": "11/19/2013 ",
        "Event Feature Date": "Blood pressure ",
        "Value": "130/84 ",
        "Expanded Value": "Blood pressure 130/84, noted in vitals ",
        "Page": 182
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "N/A ",
        "Report Date": "11/19/2013 ",
        "Event Feature Date": "Pulse ",
        "Value": "66",
        "Expanded Value": "Pulse- 66, noted in vitals ",
        "Page": 182
      },
      {
        "Impairment Category": "Basic ",
        "Impairment": "Weight ",
        "Report Date": "11/19/2013 ",
        "Event Feature Date": "Weight ",
        "Value": "163",
        "Expanded Value": "Weight- 163 lbs, noted in vitals ",
        "Page": 182
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "Hypertension ",
        "Report Date": "05/24/2013 ",
        "Event Feature Date": "Blood pressure ",
        "Value": "135/77 ",
        "Expanded Value": "Blood pressure 135/77, noted in vitals ",
        "Page": 42
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "Hypertension ",
        "Report Date": "05/16/2013 ",
        "Event Feature Date": "Blood pressure ",
        "Value": "150/86 ",
        "Expanded Value": "Blood pressure 150/86, noted in vitals ",
        "Page": 184
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "CAD ",
        "Report Date": "03/22/2013 ",
        "Event Feature Date": "Echocardiogram Ejection Fraction / LVEF / EF ",
        "Value": "54",
        "Expanded Value": "LVEF: 54% ",
        "Page": 8
      },
      {
        "Impairment Category": "N/A ",
        "Impairment": "N/A ",
        "Report Date": "03/22/2013 ",
        "Event Feature Date": "Echocardiogram Impression ",
        "Value": "normal findings ",
        "Expanded Value": "Normal diastolic function, RV function, septal motion, atrial septum ",
        "Page": 8
      },
      {
        "Impairment Category": "N/A ",
        "Impairment": "N/A ",
        "Report Date": "03/22/2013 ",
        "Event Feature Date": "Echocardiogram Impression ",
        "Value": "hypokinesis ",
        "Expanded Value": "Hypokinesis of basal posterior and apical- inferior septal segment ",
        "Page": 8
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "N/A ",
        "Report Date": "03/22/2013 ",
        "Event Feature Date": "Echocardiogram PASP ",
        "Value": "25",
        "Expanded Value": "PASP- 25 mmHg ",
        "Page": 8
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "CAD ",
        "Report Date": "03/22/2013 ",
        "Event Feature Date": "Echocardiogram - Regurgitation ",
        "Value": "tricuspid ",
        "Expanded Value": "Mild tricuspid regurgitation ",
        "Page": 8
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "CAD ",
        "Report Date": "03/22/2013 ",
        "Event Feature Date": "Echocardiogram Regurgitation ",
        "Value": "Aortic ",
        "Expanded Value": "Mild aortic regurgitation ",
        "Page": 8
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "CAD ",
        "Report Date": "03/22/2013 ",
        "Event Feature Date": "Echocardiogram - Regurgitation ",
        "Value": "mitral ",
        "Expanded Value": "Mild mitral regurgitation ",
        "Page": 8
      },
      {
        "Impairment Category": "N/A ",
        "Impairment": "N/A ",
        "Report Date": "03/22/2013 ",
        "Event Feature Date": "Echocardiogram Type ",
        "Value": "Transthoracio ",
        "Expanded Value": "Transthoracic echo ",
        "Page": 8
      },
      {
        "Impairment Category": "N/A ",
        "Impairment": "N/A ",
        "Report Date": "11/16/2012 ",
        "Event Feature Date": "Findings/Impression/Conclusion ",
        "Value": "nodules ",
        "Expanded Value": "Type: Ultrasound, Location: Neck, Indication: Thyroid nodules, Findings/Impression/Conclusion: Stable bilateral thyroid nodules ",
        "Page": 280
      },
      {
        "Impairment Category": "N/A ",
        "Impairment": "N/A ",
        "Report Date": "11/16/2012 ",
        "Event Feature Date": "Findings/Impression/Conclusion ",
        "Value": "no significant interval changes ",
        "Expanded Value": "Type: Ultrasound, Location: Neck, Indication: Thyroid nodules, Findings/Impression/Conclusion: Has been no interval change ",
        "Page": 280
      },
      {
        "Impairment Category": "N/A ",
        "Impairment": "N/A ",
        "Report Date": "11/16/2012 ",
        "Event Feature Date": "Findings/Impression/Conclusion ",
        "Value": "N/A ",
        "Expanded Value": "Type: Ultrasound, Location: Neck, Indication: Thyroid nodules, Findings/Impression/Conclusion: The largest on the right is present within the lower pole measuring 7 mm and the largest on the left is present with in the midpole measuring 6 mm ",
        "Page": 280
      },
      {
        "Impairment Category": "N/A ",
        "Impairment": "N/A ",
        "Report Date": "11/16/2012 ",
        "Event Feature Date": "Findings/Impression/Conclusior ",
        "Value": "no evidence of disease ",
        "Expanded Value": "Type: Ultrasound, Location: Neck, Indication: Thyroid nodules, Findings/Impression/Conclusion: No new nodules have developed ",
        "Page": 280
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "Hypertension ",
        "Report Date": "11/14/2012 ",
        "Event Feature Date": "Blood pressure ",
        "Value": "112/80 ",
        "Expanded Value": "Blood pressure 112/80, noted in vitals ",
        "Page": 186
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "N/A ",
        "Report Date": "11/14/2012 ",
        "Event Feature Date": "Pulse ",
        "Value": "64",
        "Expanded Value": "Pulse- 64, noted in vitals ",
        "Page": 186
      },
      {
        "Impairment Category": "Basic ",
        "Impairment": "Weight ",
        "Report Date": "11/14/2012 ",
        "Event Feature Date": "Weight ",
        "Value": "165",
        "Expanded Value": "Weight- 165 lbs, noted in vitals ",
        "Page": 186
      },
      {
        "Impairment Category": "Pulmonary ",
        "Impairment": "N/A ",
        "Report Date": "10/16/2012 ",
        "Event Feature Date": "CXR Findings ",
        "Value": "cardiomegaly ",
        "Expanded Value": "Stable mild cardiomyopathy ",
        "Page": 281
      },
      {
        "Impairment Category": "Pulmonary ",
        "Impairment": "N/A ",
        "Report Date": "10/16/2012 ",
        "Event Feature Date": "CXR Findings ",
        "Value": "pacemaker seen ",
        "Expanded Value": "Dual-lead pacemaker remains in place ",
        "Page": 281
      },
      {
        "Impairment Category": "Pulmonary ",
        "Impairment": "N/A ",
        "Report Date": "10/16/2012 ",
        "Event Feature Date": "CXR Findings ",
        "Value": "past surgery ",
        "Expanded Value": "There are surgical changes from midline thoracotomy ",
        "Page": 281
      },
      {
        "Impairment Category": "Pulmonary ",
        "Impairment": "N/A ",
        "Report Date": "10/16/2012 ",
        "Event Feature Date": "CXR Findings ",
        "Value": "tortuous aorta ",
        "Expanded Value": "The aorta is tortuous ",
        "Page": 281
      },
      {
        "Impairment Category": "Pulmonary ",
        "Impairment": "N/A ",
        "Report Date": "10/16/2012 ",
        "Event Feature Date": "CXR Findings ",
        "Value": "enlarged heart ",
        "Expanded Value": "Heart size is mildly enlarged ",
        "Page": 281
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "CAD ",
        "Report Date": "08/14/2012 ",
        "Event Feature Date": "Cardiac stress test % of maximum predicted HR for age ",
        "Value": "85",
        "Expanded Value": "MPHR- 85% ",
        "Page": 13
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "CAD ",
        "Report Date": "08/14/2012 ",
        "Event Feature Date": "Cardiac stress test EKG portion ",
        "Value": "Not specified ",
        "Expanded Value": "EKG changes could not be interpreted due to paced rhythm ",
        "Page": 13
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "CAD ",
        "Report Date": "08/14/2012 ",
        "Event Feature Date": "Cardiac stress test Exercise tolerance ",
        "Value": "excellent ",
        "Expanded Value": "Excellent exercise performance ",
        "Page": 13
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "CAD ",
        "Report Date": "08/14/2012 ",
        "Event Feature Date": "Cardiac stress test METS (metabolic equivalent task) ",
        "Value": "11",
        "Expanded Value": "METS: 11 ",
        "Page": 13
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "CAD ",
        "Report Date": "08/14/2012 ",
        "Event Feature Date": "Cardiac stress test Overall ",
        "Value": "no ischemia ",
        "Expanded Value": "Large, severe non-reversible infarct of the inferior and posterior left ventricular wall with no associated borderline ischemia ",
        "Page": 14
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "CAD ",
        "Report Date": "08/14/2012 ",
        "Event Feature Date": "Cardiac stress test Stress Ejection Fraction % ",
        "Value": "44",
        "Expanded Value": "Stress EF: 44% ",
        "Page": 14
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "CAD ",
        "Report Date": "08/14/2012 ",
        "Event Feature Date": "Cardiac stress test Symptoms during exercise ",
        "Value": "Fatigue ",
        "Expanded Value": "Terminated- Fatigue, Shortness of breath ",
        "Page": 13
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "CAD ",
        "Report Date": "08/14/2012 ",
        "Event Feature Date": "Cardiac stress test Symptoms during exercise ",
        "Value": "shortness of breath ",
        "Expanded Value": "Terminated- Fatigue, Shortness of breath ",
        "Page": 13
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "CAD ",
        "Report Date": "08/14/2012 ",
        "Event Feature Date": "Cardiac stress test Type ",
        "Value": "Nuclear ",
        "Expanded Value": "Treadmill nuclear stress test ",
        "Page": 13
      },
      {
        "Impairment Category": "Pulmonary ",
        "Impairment": "N/A ",
        "Report Date": "05/23/2012 ",
        "Event Feature Date": "CXR Findings ",
        "Value": "past surgery ",
        "Expanded Value": "Heart size and pulmonary vascular pattern are normal status post median sternotomy and coronary artery bypass grafting procedure ",
        "Page": 282
      },
      {
        "Impairment Category": "Pulmonary ",
        "Impairment": "N/A ",
        "Report Date": "05/23/2012 ",
        "Event Feature Date": "CXR Findings ",
        "Value": "atelectasis ",
        "Expanded Value": "Linear atelectasis is noted within the right lower lobe ",
        "Page": 282
      },
      {
        "Impairment Category": "Pulmonary ",
        "Impairment": "N/A ",
        "Report Date": "05/23/2012 ",
        "Event Feature Date": "CXR Findings ",
        "Value": "no infiltrate ",
        "Expanded Value": "No confluent pulmonary infiltrates or pleural effusion ",
        "Page": 282
      },
      {
        "Impairment Category": "N/A ",
        "Impairment": "N/A ",
        "Report Date": "11/21/2011 ",
        "Event Feature Date": "Findings/Impression/Conclusion ",
        "Value": "nodules ",
        "Expanded Value": "Type: Ultrasound, Location: Neck, Indication: Thyroid nodule, Findings/Impression/Conclusion: Stable bilateral thyroid nodules ",
        "Page": 283
      },
      {
        "Impairment Category": "N/A ",
        "Impairment": "N/A ",
        "Report Date": "11/21/2011 ",
        "Event Feature Date": "Findings/Impression/Conclusion ",
        "Value": "no significant interval changes ",
        "Expanded Value": "Type: Ultrasound, Location: Neck, Indication: Thyroid nodule, Findings/Impression/Conclusion: No significant change ",
        "Page": 283
      },
      {
        "Impairment Category": "N/A ",
        "Impairment": "N/A ",
        "Report Date": "11/21/2011 ",
        "Event Feature Date": "Findings/Impression/Conclusion ",
        "Value": "N/A ",
        "Expanded Value": "Type: Ultrasound, Location: Neck, Indication: Thyroid nodule, Findings/Impression/Conclusion: The largest on the right measures 8 mm and the largest on the left 7mm ",
        "Page": 283
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "Hypertension ",
        "Report Date": "11/16/2011 ",
        "Event Feature Date": "Blood pressure ",
        "Value": "112/78 ",
        "Expanded Value": "Blood pressure 112/78, noted in vitals ",
        "Page": 190
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "N/A ",
        "Report Date": "11/16/2011 ",
        "Event Feature Date": "Pulse ",
        "Value": "58",
        "Expanded Value": "Pulse- 58, noted in vitals ",
        "Page": 190
      },
      {
        "Impairment Category": "Basic ",
        "Impairment": "Weight ",
        "Report Date": "11/16/2011 ",
        "Event Feature Date": "Weight ",
        "Value": "170",
        "Expanded Value": "Weight- 170 lbs, noted in vitals ",
        "Page": 190
      },
      {
        "Impairment Category": "Cerebrovascular ",
        "Impairment": "carotid stenosis ",
        "Report Date": "08/09/2011",
        "Event Feature Date": "Carotid ultrasound/doppler/duplex ",
        "Value": "no significant stenosis ",
        "Expanded Value": "No evidence of significant atherosclerosis in the right internal carotid artery ",
        "Page": 18
      },
      {
        "Impairment Category": "Cerebrovascular ",
        "Impairment": "carotid stenosis ",
        "Report Date": "08/09/2011",
        "Event Feature Date": "Carotid ultrasound/doppler/duplex ",
        "Value": "Atherosclerosis ",
        "Expanded Value": "Mild atherosclerosis in the left internal carotid artery (<50% stenosis) ",
        "Page": 18
      },
      {
        "Impairment Category": "Cerebrovascular ",
        "Impairment": "carotid stenosis ",
        "Report Date": "08/09/2011",
        "Event Feature Date": "Carotid ultrasound/doppler/duplex ",
        "Value": "bilateral ",
        "Expanded Value": "Normal antegrade flow in the right and left vertebral arteries ",
        "Page": 18
      },
      {
        "Impairment Category": "Cerebrovascular ",
        "Impairment": "carotid stenosis ",
        "Report Date": "08/09/2011",
        "Event Feature Date": "Carotid ultrasound/doppler/duplex - LICA ",
        "Value": "<50 ",
        "Expanded Value": "Irregular heterogeneous plaque in the proximal internal carotid artery (<50% stenosis) ",
        "Page": 18
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "CAD ",
        "Report Date": "08/09/2011",
        "Event Feature Date": "Echocardiogram Ejection Fraction / LVEF / EF ",
        "Value": "40",
        "Expanded Value": "LVEF: 40% ",
        "Page": 11
      },
      {
        "Impairment Category": "N/A ",
        "Impairment": "N/A ",
        "Report Date": "08/09/2011",
        "Event Feature Date": "Echocardiogram Impression ",
        "Value": "normal findings ",
        "Expanded Value": "Normal septal motion, atrial septum ",
        "Page": 11
      },
      {
        "Impairment Category": "N/A ",
        "Impairment": "N/A ",
        "Report Date": "08/09/2011",
        "Event Feature Date": "Echocardiogram Impression ",
        "Value": "impaired relaxation ",
        "Expanded Value": "Diastolic function- Impaired relaxation ",
        "Page": 11
      },
      {
        "Impairment Category": "N/A ",
        "Impairment": "N/A ",
        "Report Date": "08/09/2011",
        "Event Feature Date": "Echocardiogram Impression ",
        "Value": "hypokinesis ",
        "Expanded Value": "Generalized mild LV hypokinesis ",
        "Page": 11
      },
      {
        "Impairment Category": "N/A ",
        "Impairment": "N/A ",
        "Report Date": "08/09/2011",
        "Event Feature Date": "Echocardiogram Impression ",
        "Value": "Akinesis ",
        "Expanded Value": "Inferior akinesis ",
        "Page": 11
      },
      {
        "Impairment Category": "N/A ",
        "Impairment": "N/A ",
        "Report Date": "08/09/2011",
        "Event Feature Date": "Echocardiogram Impression ",
        "Value": "hypokinesis ",
        "Expanded Value": "Marked lateral hypokinesis ",
        "Page": 11
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "N/A ",
        "Report Date": "08/09/2011",
        "Event Feature Date": "Echocardiogram PASP ",
        "Value": "30",
        "Expanded Value": "PASP- 30 mmHg ",
        "Page": 11
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "CAD ",
        "Report Date": "08/09/2011",
        "Event Feature Date": "Echocardiogram Regurgitation ",
        "Value": "mitral ",
        "Expanded Value": "Mild mitral regurgitation ",
        "Page": 11
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "CAD ",
        "Report Date": "08/09/2011",
        "Event Feature Date": "Echocardiogram - Regurgitation ",
        "Value": "tricuspid ",
        "Expanded Value": "Mild tricuspid valve regurgitation ",
        "Page": 11
      },
      {
        "Impairment Category": "N/A ",
        "Impairment": "N/A ",
        "Report Date": "08/09/2011",
        "Event Feature Date": "Echocardiogram Type ",
        "Value": "Transthoracic ",
        "Expanded Value": "Transthoracic with doppler echo ",
        "Page": 11
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "CAD ",
        "Report Date": "08/02/2011",
        "Event Feature Date": "EKG Heart blocks ",
        "Value": "intraventricular conduction delay ",
        "Expanded Value": "Non-specific intraventricular conduction delay ",
        "Page": 12
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "CAD ",
        "Report Date": "08/02/2011",
        "Event Feature Date": "EKG Heart rate ",
        "Value": "49",
        "Expanded Value": "Heart rate: 49 ",
        "Page": 12
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "CAD ",
        "Report Date": "08/02/2011",
        "Event Feature Date": "EKG Overall ",
        "Value": "abnormal ",
        "Expanded Value": "Abnormal EKG ",
        "Page": 12
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "Hypertension ",
        "Report Date": "05/18/2011 ",
        "Event Feature Date": "Blood pressure ",
        "Value": "148/82 ",
        "Expanded Value": "Blood pressure 148/82, noted in vitals ",
        "Page": 191
      },
      {
        "Impairment Category": "Gastrointestinal ",
        "Impairment": "N/A ",
        "Report Date": "11/19/2010 ",
        "Event Feature Date": "Findings/Impression/Conclusior ",
        "Value": "atherosclerosis ",
        "Expanded Value": "Type: CT, Location: Abdomen and pelvis, Indication: Elevated lipase, Findings/Impression/Conclusion: Atherosclerotic disease of the descending aorta with dissection extending into the right iliac artery ",
        "Page": 276
      },
      {
        "Impairment Category": "Gastrointestinal ",
        "Impairment": "N/A ",
        "Report Date": "11/19/2010 ",
        "Event Feature Date": "Findings/Impression/Conclusior ",
        "Value": "enlarged prostate ",
        "Expanded Value": "Type: CT, Location: Abdomen and pelvis, Indication: Elevated lipase, Findings/Impression/Conclusion: Enlarged prostate and thick walled bladder ",
        "Page": 276
      },
      {
        "Impairment Category": "Gastrointestinal ",
        "Impairment": "N/A ",
        "Report Date": "11/19/2010 ",
        "Event Feature Date": "Findings/Impression/Conclusior ",
        "Value": "normal findings ",
        "Expanded Value": "Type: CT, Location: Abdomen and pelvis, Indication: Elevated lipase, Findings/Impression/Conclusion: The liver, pancreas, spleen, gallbladder and adrenal glands appear normal ",
        "Page": 276
      },
      {
        "Impairment Category": "Gastrointestinal ",
        "Impairment": "N/A ",
        "Report Date": "11/19/2010 ",
        "Event Feature Date": "Findings/Impression/Conclusior ",
        "Value": "renal cyst(s) ",
        "Expanded Value": "Type: CT, Location: Abdomen and pelvis, Indication: Elevated lipase, Findings/Impression/Conclusion:Small renal cysts are present ",
        "Page": 276
      },
      {
        "Impairment Category": "Gastrointestinal ",
        "Impairment": "N/A ",
        "Report Date": "11/19/2010 ",
        "Event Feature Date": "Findings/Impression/Conclusion ",
        "Value": "diverticulosis ",
        "Expanded Value": "Type: CT, Location: Abdomen and pelvis, Indication: Elevated lipase, Findings/Impression/Conclusion: There are numerous colonic diverticula but no evidence of diverticulitis ",
        "Page": 276
      },
      {
        "Impairment Category": "Gastrointestinal ",
        "Impairment": "N/A ",
        "Report Date": "11/19/2010 ",
        "Event Feature Date": "Findings/Impression/Conclusion ",
        "Value": "calcification ",
        "Expanded Value": "Type: CT, Location: Abdomen and pelvis, Indication: Elevated lipase, Findings/Impression/Conclusion The aorta is normal in caliber but is calcified ",
        "Page": 276
      },
      {
        "Impairment Category": "Gastrointestinal ",
        "Impairment": "N/A ",
        "Report Date": "11/19/2010 ",
        "Event Feature Date": "Findings/Impression/Conclusior ",
        "Value": "plaque ",
        "Expanded Value": "Type: CT, Location: Abdomen and pelvis, Indication: Elevated lipase, Findings/Impression/Conclusion: There is irregular plaque ",
        "Page": 276
      },
      {
        "Impairment Category": "Gastrointestinal ",
        "Impairment": "N/A ",
        "Report Date": "11/19/2010 ",
        "Event Feature Date": "Findings/Impression/Conclusion ",
        "Value": "no evidence of disease ",
        "Expanded Value": "Type: CT, Location: Abdomen and pelvis, Indication: Elevated lipase, Findings/Impression/Conclusion: No adenopathy is seen, no ascites is present ",
        "Page": 276
      },
      {
        "Impairment Category": "Pulmonary ",
        "Impairment": "N/A ",
        "Report Date": "11/19/2010 ",
        "Event Feature Date": "Findings/Impression/Conclusior ",
        "Value": "atelectasis ",
        "Expanded Value": "Type: CT, Location: Abdomen and pelvis, Indication: Elevated lipase, Findings/Impression/Conclusion: There is atelectasis in the right lower lobe ",
        "Page": 276
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "N/A ",
        "Report Date": "11/19/2010 ",
        "Event Feature Date": "Findings/Impression/Conclusior ",
        "Value": "N/A ",
        "Expanded Value": "Type: CT, Location: Abdomen and pelvis, Indication: Elevated lipase, Findings/Impression/Conclusion: The heart size is enlarged ",
        "Page": 276
      },
      {
        "Impairment Category": "Orthopedic ",
        "Impairment": "N/A ",
        "Report Date": "11/19/2010 ",
        "Event Feature Date": "Findings/Impression/Conclusion ",
        "Value": "degenerative changes ",
        "Expanded Value": "Type: CT, Location: Abdomen and pelvis, Indication: Elevated lipase, Findings/Impression/Conclusion: Degenerative changes in the spine ",
        "Page": 276
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "Hypertension ",
        "Report Date": "11/16/2010 ",
        "Event Feature Date": "Blood pressure ",
        "Value": "124/78 ",
        "Expanded Value": "Blood pressure 124/78, noted in vitals ",
        "Page": 193
      },
      {
        "Impairment Category": "Lifestyle ",
        "Impairment": "Temperature ",
        "Report Date": "11/16/2010 ",
        "Event Feature Date": "Body temperature ",
        "Value": "97.1",
        "Expanded Value": "Temperature-97.1, noted in vitals ",
        "Page": 193
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "N/A ",
        "Report Date": "11/16/2010 ",
        "Event Feature Date": "Pulse ",
        "Value": "60",
        "Expanded Value": "Pulse- 60, noted in vitals ",
        "Page": 193
      },
      {
        "Impairment Category": "Basic ",
        "Impairment": "Weight ",
        "Report Date": "11/16/2010 ",
        "Event Feature Date": "Weight ",
        "Value": "166",
        "Expanded Value": "Weight- 166 lbs, noted in vitals ",
        "Page": 193
      },
      {
        "Impairment Category": "N/A ",
        "Impairment": "N/A ",
        "Report Date": "09/16/2010 ",
        "Event Feature Date": "Findings/Impression/Conclusior ",
        "Value": "lesion ",
        "Expanded Value": "Type: Ultrasound, Location: Neck, Indication: Hyperthyroidism, Findings/Impression/Conclusion: Several subcentimeter indeterminate lesions within both lobes without dominant solid nodule ",
        "Page": 287
      },
      {
        "Impairment Category": "N/A ",
        "Impairment": "N/A ",
        "Report Date": "09/16/2010 ",
        "Event Feature Date": "Findings/Impression/Conclusion ",
        "Value": "cyst(s)-type ",
        "Expanded Value": "Type: Ultrasound, Location: Neck, Indication: Hyperthyroidism, Findings/Impression/Conclusion: Cystic lesion on the right measures 8 mm within the lower pole ",
        "Page": 287
      },
      {
        "Impairment Category": "N/A ",
        "Impairment": "N/A ",
        "Report Date": "09/16/2010 ",
        "Event Feature Date": "Findings/Impression/Conclusior ",
        "Value": "lesion ",
        "Expanded Value": "Type: Ultrasound, Location: Neck, Indication: Hyperthyroidism Findings/Impression/Conclusion: Largest lesion on the left measures 6 mm within the lower pole ",
        "Page": 287
      },
      {
        "Impairment Category": "Orthopedic ",
        "Impairment": "N/A ",
        "Report Date": "09/08/2010",
        "Event Feature Date": "Findings/Impression/Conclusion ",
        "Value": "DDD ",
        "Expanded Value": "Type: Xray, Location: Cervical spine and lumbar spine, Indication: Neck pain and bilateral lower extremity radiculopathy, Findings/Impression/Conclusion: Moderate C5-C6 and C6-C7 degenerative disc disease ",
        "Page": 286
      },
      {
        "Impairment Category": "Orthopedic ",
        "Impairment": "N/A ",
        "Report Date": "09/08/2010",
        "Event Feature Date": "Findings/Impression/Conclusior ",
        "Value": "osteoarthritis ",
        "Expanded Value": "Type: Xray, Location: Cervical spine and lumbar spine, Indication: Neck pain and bilateral lower extremity radiculopathy, Findings/Impression/Conclusion: Facet osteoarthritis ",
        "Page": 286
      },
      {
        "Impairment Category": "Orthopedic ",
        "Impairment": "N/A ",
        "Report Date": "09/08/2010",
        "Event Feature Date": "Findings/Impression/Conclusior ",
        "Value": "N/A ",
        "Expanded Value": "Type: Xray, Location: Cervical spine and lumbar spine, Indication: Neck pain and bilateral lower extremity radiculopathy, Findings/Impression/Conclusion Uncovertebral joint hypertrophy which results in moderate right C5-C6 neuroforaminal narrowing ",
        "Page": 286
      },
      {
        "Impairment Category": "Orthopedic ",
        "Impairment": "N/A ",
        "Report Date": "09/08/2010",
        "Event Feature Date": "Findings/Impression/Conclusion ",
        "Value": "no fracture ",
        "Expanded Value": "Type: Xray, Location: Cervical spine and lumbar spine, Indication: Neck pain and bilateral lower extremity radiculopathy, Findings/Impression/Conclusion: No fracture are seen ",
        "Page": 286
      },
      {
        "Impairment Category": "Orthopedic ",
        "Impairment": "N/A ",
        "Report Date": "09/08/2010",
        "Event Feature Date": "Findings/Impression/Conclusior ",
        "Value": "Anterolisthesis ",
        "Expanded Value": "Type: Xray, Location: Cervical spine and lumbar spine, Indication: Neck pain and bilateral lower extremity radiculopathy, Findings/Impression/Conclusion: Moderately right C5-C6 neuroforaminal narrowing there is approximately 4 mm of anterolisthesis of C4 on C5 ",
        "Page": 286
      },
      {
        "Impairment Category": "Orthopedic ",
        "Impairment": "N/A ",
        "Report Date": "09/08/2010",
        "Event Feature Date": "Findings/Impression/Conclusion ",
        "Value": "normal findings ",
        "Expanded Value": "Type: Xray, Location: Cervical spine and lumbar spine, Indication: Neck pain and bilateral lower extremity radiculopathy, Findings/Impression/Conclusion Prevertebral soft tissue and craniocervical junction appear normal ",
        "Page": 286
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "Hypertension ",
        "Report Date": "05/10/2010",
        "Event Feature Date": "Blood pressure ",
        "Value": "132/80 ",
        "Expanded Value": "Blood pressure 132/80, noted in vitals ",
        "Page": 199
      }
    ],
    "Impairments": [
      {
        "Impairment Category": "Cancer ",
        "Impairment": "prostate cancer ",
        "Feature": "Gleason Score ",
        "Report Date": "06/01/2015",
        "Event Date": "",
        "Clinician Name": "****** MD ",
        "Clinician Specialty": "General ",
        "Value": "6",
        "Expanded Value": "Prostate cancer- Gleason score 6 adenocarcinoma, noted in HPI ",
        "Page": 33
      },
      {
        "Impairment Category": "Cancer ",
        "Impairment": "prostate cancer ",
        "Feature": "Stage ",
        "Report Date": "06/01/2015",
        "Event Date": "",
        "Clinician Name": "****** MD ",
        "Clinician Specialty": "General ",
        "Value": "I ",
        "Expanded Value": "Prostate cancer-TNM staging T1cNXMX Stage I, noted in HPI ",
        "Page": 33
      },
      {
        "Impairment Category": "Cancer ",
        "Impairment": "prostate cancer ",
        "Feature": "TNM Staging ",
        "Report Date": "06/01/2015",
        "Event Date": "",
        "Clinician Name": "****** MD ",
        "Clinician Specialty": "General ",
        "Value": "T1c NX Mx ",
        "Expanded Value": "Prostate cancer-TNM staging- T1cNXMX, noted in HPI ",
        "Page": 33
      },
      {
        "Impairment Category": "Cancer ",
        "Impairment": "prostate cancer ",
        "Feature": "Treatment for cancer ",
        "Report Date": "06/01/2015",
        "Event Date": "11/01/2002",
        "Clinician Name": "****** MD ",
        "Clinician Specialty": "General ",
        "Value": "radiation ",
        "Expanded Value": "Prostate cancer- Initial treatment consisted of radiation therapy and was undertaken/initiated in November 2002, noted in HPI ",
        "Page": 33
      },
      {
        "Impairment Category": "Cancer ",
        "Impairment": "prostate cancer ",
        "Feature": "Type of cancer ",
        "Report Date": "06/01/2015",
        "Event Date": "05/01/2002",
        "Clinician Name": "****** MD ",
        "Clinician Specialty": "General ",
        "Value": "Prostate cancer ",
        "Expanded Value": "Prostate cancer was first diagnosed in May 2002, noted in HPI ",
        "Page": 33
      },
      {
        "Impairment Category": "Cancer ",
        "Impairment": "prostate cancer ",
        "Feature": "Type of prostate cancer ",
        "Report Date": "06/01/2015",
        "Event Date": "",
        "Clinician Name": "****** MD ",
        "Clinician Specialty": "General ",
        "Value": "Adenocarcinoma ",
        "Expanded Value": "Prostate cancer- Gleason score 6 adenocarcinoma, noted in HPI ",
        "Page": 33
      },
      {
        "Impairment Category": "Endocrine ",
        "Impairment": "prediabetes ",
        "Feature": "Endocrine disorders ",
        "Report Date": "05/19/2015 ",
        "Event Date": "01/01/1900",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Value": "pre-diabetes ",
        "Expanded Value": "History of prediabetes, noted in HPI ",
        "Page": 175
      },
      {
        "Impairment Category": "Endocrine ",
        "Impairment": "hypothyroidism ",
        "Feature": "Endocrine disorders ",
        "Report Date": "05/19/2015 ",
        "Event Date": "01/01/1900",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Value": "Hypothyroidism ",
        "Expanded Value": "History of hypothyroidism, noted in HPI ",
        "Page": 175
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "MI ",
        "Feature": "ICD placement ",
        "Report Date": "05/19/2015 ",
        "Event Date": "01/01/1900",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Value": "Yes ",
        "Expanded Value": "History of status post MI X2, status post pacemaker and defibrillator, noted in HPI ",
        "Page": 175
      },
      {
        "Impairment Category": "Endocrine ",
        "Impairment": "prediabetes ",
        "Feature": "Endocrine disorders ",
        "Report Date": "11/18/2014 ",
        "Event Date": "01/01/1900",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Value": "impaired fasting glucose ",
        "Expanded Value": "History of impaired fasting glucose, noted in assessment ",
        "Page": 177
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "CAD ",
        "Feature": "Other surgical procedures ",
        "Report Date": "11/11/2014",
        "Event Date": "01/01/1900",
        "Clinician Name": "****** MD ",
        "Clinician Specialty": "Cardiology ",
        "Value": "angioplasty ",
        "Expanded Value": "Coronary artery disease- Bypass grafting, noted in PMH ",
        "Page": 6
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "Atheroclerosis ",
        "Feature": "Disease present ",
        "Report Date": "11/11/2014",
        "Event Date": "11/21/2013 ",
        "Clinician Name": "****** MD ",
        "Clinician Specialty": "Cardiology ",
        "Value": "Heart ",
        "Expanded Value": "Coronary atherosclerosis native vessel-onset- 11/21/2013, noted in problem list ",
        "Page": 5
      },
      {
        "Impairment Category": "Gastrointestinal ",
        "Impairment": "diverticulosis ",
        "Feature": "Gastrointestinal disorders ",
        "Report Date": "11/11/2014",
        "Event Date": "01/01/1900",
        "Clinician Name": "****** MD ",
        "Clinician Specialty": "Cardiology ",
        "Value": "Diverticulosis ",
        "Expanded Value": "Diverticulosis, noted in PMH ",
        "Page": 6
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "CAD ",
        "Feature": "ICD placement ",
        "Report Date": "11/11/2014",
        "Event Date": "01/01/1900",
        "Clinician Name": "****** MD ",
        "Clinician Specialty": "Cardiology ",
        "Value": "Yes ",
        "Expanded Value": "Coronary artery disease- Implantable defibrillator, noted in PHH ",
        "Page": 6
      },
      {
        "Impairment Category": "Cerebrovascular ",
        "Impairment": "carotid artery disease ",
        "Feature": "Other cerebrovascular type ",
        "Report Date": "11/11/2014",
        "Event Date": "11/21/2013 ",
        "Clinician Name": "****** MD ",
        "Clinician Specialty": "Cardiology ",
        "Value": "carotid artery disease ",
        "Expanded Value": "Occlusive and stenosis carotid artery disease without infarct-onset- 11/21/2013, noted in problem list ",
        "Page": 5
      },
      {
        "Impairment Category": "Endocrine ",
        "Impairment": "hypothyroidism ",
        "Feature": "Endocrine disorders ",
        "Report Date": "05/28/2014 ",
        "Event Date": "01/01/1900",
        "Clinician Name": "****** MD ",
        "Clinician Specialty": "General ",
        "Value": "Hypothyroidism ",
        "Expanded Value": "Hypothyroid, noted in problems ",
        "Page": 37
      },
      {
        "Impairment Category": "Cancer ",
        "Impairment": "prostate cancer ",
        "Feature": "Recurrence ",
        "Report Date": "05/20/2014 ",
        "Event Date": "01/01/1900",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Value": "No ",
        "Expanded Value": "History of prostate cancer in 2002 without recurrence, noted in HPI ",
        "Page": 180
      },
      {
        "Impairment Category": "Gastrointestinal ",
        "Impairment": "colon polyps ",
        "Feature": "Gastrointestinal disorders ",
        "Report Date": "05/20/2014 ",
        "Event Date": "",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Value": "colon polyps ",
        "Expanded Value": "History of colon polyps, noted in HPI ",
        "Page": 180
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "ischemic cardiomyopathy ",
        "Feature": "Cardiomyopathy Type ",
        "Report Date": "05/20/2014 ",
        "Event Date": "01/01/1900",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Value": "Ischemic Cardiomyopathy (ICM) ",
        "Expanded Value": "History of ischemic cardiomyopathy, noted in HPI ",
        "Page": 180
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "CAD ",
        "Feature": "Other surgical procedures ",
        "Report Date": "11/21/2013 ",
        "Event Date": "01/01/2003",
        "Clinician Name": "****** MD ",
        "Clinician Specialty": "Cardiology ",
        "Value": "angioplasty ",
        "Expanded Value": "Coronary artery disease status post coronary bypass grafting in 2003, noted in HPI ",
        "Page": 2
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "Atheroclerosis ",
        "Feature": "Disease present ",
        "Report Date": "11/21/2013 ",
        "Event Date": "",
        "Clinician Name": "****** MD ",
        "Clinician Specialty": "Cardiology ",
        "Value": "Heart ",
        "Expanded Value": "Coronary atherosclerosis native vessel, noted in assessment ",
        "Page": 1
      },
      {
        "Impairment Category": "Gastrointestinal ",
        "Impairment": "diverticulosis ",
        "Feature": "Gastrointestinal disorders ",
        "Report Date": "11/21/2013 ",
        "Event Date": "01/01/1900",
        "Clinician Name": "****** MD ",
        "Clinician Specialty": "Cardiology ",
        "Value": "Diverticulosis ",
        "Expanded Value": "Diverticulosis, noted in PMH ",
        "Page": 2
      },
      {
        "Impairment Category": "No Match ",
        "Impairment": "peripheral vascular disease ",
        "Feature": "In medical history only ",
        "Report Date": "11/21/2013 ",
        "Event Date": "01/01/1900",
        "Clinician Name": "****** MD ",
        "Clinician Specialty": "Cardiology ",
        "Value": "> 1 mention ",
        "Expanded Value": "Peripheral vascular disease, noted in cardiac history ",
        "Page": 2
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "ischemic cardiomyopathy ",
        "Feature": "ICD placement ",
        "Report Date": "11/21/2013 ",
        "Event Date": "01/01/1900",
        "Clinician Name": "****** MD ",
        "Clinician Specialty": "Cardiology ",
        "Value": "Yes ",
        "Expanded Value": "Has ischemic cardiomyopathy, status post defibrillator implantation, noted in HPI ",
        "Page": 2
      },
      {
        "Impairment Category": "Cerebrovascular ",
        "Impairment": "carotid artery disease ",
        "Feature": "Other cerebrovascular type ",
        "Report Date": "11/21/2013 ",
        "Event Date": "",
        "Clinician Name": "****** MD ",
        "Clinician Specialty": "Cardiology ",
        "Value": "carotid artery disease ",
        "Expanded Value": "Occlusive carotid artery without infarct, noted in assessment ",
        "Page": 1
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "CAD ",
        "Feature": "Symptoms ",
        "Report Date": "11/19/2013 ",
        "Event Date": "",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Value": "asymptomatic ",
        "Expanded Value": "Coronary heart disease, no active symptoms, currently will follow up with Dr. Kopitsky, noted in assessment ",
        "Page": 182
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "Arrhythmias ",
        "Feature": "Arrhythmias Cause ",
        "Report Date": "05/16/2013 ",
        "Event Date": "01/01/1900",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Value": "cardiomyopathy ",
        "Expanded Value": "History of ischemic cardiomyopathy with ventricular arrhythmias, noted in assessment ",
        "Page": 185
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "palpitations ",
        "Feature": "Arrhythmias Type ",
        "Report Date": "10/16/2012 ",
        "Event Date": "",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Value": "palpitations ",
        "Expanded Value": "Had some increased frequency of palpitations, noted in HPI ",
        "Page": 187
      },
      {
        "Impairment Category": "Endocrine ",
        "Impairment": "prediabetes ",
        "Feature": "Endocrine disorders ",
        "Report Date": "05/23/2012 ",
        "Event Date": "01/01/1900",
        "Clinician Name": "****** MD ",
        "Clinician Specialty": "General ",
        "Value": "impaired fasting glucose ",
        "Expanded Value": "History of prediabetes with mild impaired fasting glucose, noted in assessment ",
        "Page": 189
      },
      {
        "Impairment Category": "Neurological ",
        "Impairment": "memory issues ",
        "Feature": "Memory loss ",
        "Report Date": "05/23/2012 ",
        "Event Date": "",
        "Clinician Name": "****** MD ",
        "Clinician Specialty": "General ",
        "Value": "short-term ",
        "Expanded Value": "Some mild issues with short term memory but nothing that interferes with his ability at functioning, noted in HPI ",
        "Page": 188
      },
      {
        "Impairment Category": "Endocrine ",
        "Impairment": "prediabetes ",
        "Feature": "Endocrine disorders ",
        "Report Date": "05/18/2011 ",
        "Event Date": "01/01/1900",
        "Clinician Name": "*******man ",
        "Clinician Specialty": "General ",
        "Value": "pre-diabetes ",
        "Expanded Value": "History of prediabetes, noted in assessment ",
        "Page": 192
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "ischemic cardiomyopathy ",
        "Feature": "Cardiomyopathy Type ",
        "Report Date": "05/10/2010",
        "Event Date": "",
        "Clinician Name": "****** MD ",
        "Clinician Specialty": "General ",
        "Value": "Ischemic Cardiomyopathy (ICM) ",
        "Expanded Value": "Ischemic cardiomyopathy-very stable, noted in assessment ",
        "Page": 199
      },
      {
        "Impairment Category": "CAD/Cardiovascular ",
        "Impairment": "MI ",
        "Feature": "Type of heart attack ",
        "Report Date": "06/03/2002",
        "Event Date": "01/01/1975",
        "Clinician Name": "****** MD ",
        "Clinician Specialty": "General ",
        "Value": "N/A ",
        "Expanded Value": "Status post myocardial infarction times two treated with drug therapy since age 35, noted in PMH ",
        "Page": 90
      },
      {
        "Impairment Category": "Cancer ",
        "Impairment": "prostate cancer ",
        "Feature": "Gleason Score ",
        "Report Date": "06/03/2002",
        "Event Date": "",
        "Clinician Name": "****** MD ",
        "Clinician Specialty": "General ",
        "Value": "VI ",
        "Expanded Value": "Prostate cancer- Gleason score VI adenocarcinoma, noted in HPI ",
        "Page": 90
      },
      {
        "Impairment Category": "Cancer ",
        "Impairment": "prostate cancer ",
        "Feature": "Type of cancer ",
        "Report Date": "06/03/2002",
        "Event Date": "",
        "Clinician Name": "****** MD ",
        "Clinician Specialty": "General ",
        "Value": "Prostate cancer ",
        "Expanded Value": "Prostate cancer- Gleason score VI adenocarcinoma, noted in HPI ",
        "Page": 90
      },
      {
        "Impairment Category": "Cancer ",
        "Impairment": "prostate cancer ",
        "Feature": "Type of prostate cancer ",
        "Report Date": "06/03/2002",
        "Event Date": "",
        "Clinician Name": "****** MD ",
        "Clinician Specialty": "General ",
        "Value": "Adenocarcinoma ",
        "Expanded Value": "Prostate cancer- Gleason score VI adenocarcinoma, noted in HPI ",
        "Page": 90
      }
    ]
  },
  "generalInfo": {
    "Name": '****',
    "Gender": 'Male',
    "Age": '81',
    "heigh": "5'10'' (06/01/2015)",
    "Weight": "160 Lbs (06/01/2015)",
    "BMI": '22.96', 
    "DOB": '06/02/1940',
    "Medical Records Start Date": "03/01/1999",
    "Medical Records End Date": "06/21/2015",
    "Marital Status": "Married",
    "Address": "13651 Peacock Farm Rd",
    "State": '',
    "SSN": '****',
    "Life Expectancy Mean": '78 Month',
    "Life Expectancy Median": '81 Month'
  },
  "le": {
    "dies": [7, 8, 10, 10, 10, 9, 9, 8, 7, 5, 5, 4, 3, 2, 1, 1, 1],
    "lives": [100, 93, 85, 75, 65, 55, 46, 37, 29, 22, 17, 12, 8, 5, 3, 2, 1]
  },
  "Troubleshooting" : [
    {
      "File Name": "LR-Meds1-DrS-032999-060115",
      "Page Number": 11,
      "Problem": "Hand Writing",
      "Severity": "Low"
    },
    {
      "File Name": "LR-Meds1-DrS-032999-060115",
      "Page Number": 24,
      "Problem": "Hand Writing",
      "Severity": "Medium"
    },
    {
      "File Name": "LR-Meds1-DrS-032999-060115",
      "Page Number": 36,
      "Problem": "Poor Scan",
      "Severity": "Medium"
    },
    {
      "File Name": "LR-Meds2-DrK-080911-111114",
      "Page Number": 72,
      "Problem": "Unidentified",
      "Severity": "Medium"
    },
    {
      "File Name": "LR-Meds2-DrK-080911-111114",
      "Page Number": 97,
      "Problem": "Unidentified",
      "Severity": "Medium"
    },
    {
      "File Name": "LR-Meds2-DrK-080911-111114",
      "Page Number": 112,
      "Problem": "Hand Writing",
      "Severity": "Low"
    },
    {
      "File Name": "LR-Meds2-DrK-080911-111114",
      "Page Number": 125,
      "Problem": "Unidentified",
      "Severity": "Low"
    },
    {
      "File Name": "LR-Meds2-DrK-080911-111114",
      "Page Number": 180,
      "Problem": "Hand Writing",
      "Severity": "Low"
    },
    {
      "File Name": "LR-Meds2-DrK-080911-111114",
      "Page Number": 184,
      "Problem": "Unidentified",
      "Severity": "Medium"
    },
    {
      "File Name": "LR-Meds2-DrK-080911-111114",
      "Page Number": 185,
      "Problem": "Poor Scan",
      "Severity": "Low"
    },
    {
      "File Name": "LR-Meds2-DrK-080911-111114",
      "Page Number": 188,
      "Problem": "Unidentified",
      "Severity": "Medium"
    },
    {
      "File Name": "LR-Meds2-DrK-080911-111114",
      "Page Number": 189,
      "Problem": "Unidentified",
      "Severity": "High"
    },
    {
      "File Name": "LR-Meds2-DrK-080911-111114",
      "Page Number": 237,
      "Problem": "Poor Scan",
      "Severity": "Low"
    },
    {
      "File Name": "LR-Meds2-DrK-080911-111114",
      "Page Number": 311,
      "Problem": "Hand Writing",
      "Severity": "Low"
    },
    {
      "File Name": "LR-Meds3-DrS-050510-051915",
      "Page Number": 332,
      "Problem": "Hand Writing",
      "Severity": "Low"
    },
    {
      "File Name": "LR-Meds3-DrS-050510-051915",
      "Page Number": 351,
      "Problem": "Hand Writing",
      "Severity": "Medium"
    },
    {
      "File Name": "LR-Meds3-DrS-050510-051915",
      "Page Number": 362,
      "Problem": "Hand Writing",
      "Severity": "Low"
    }
   ]

}